__turbopack_context__.v({
  "body": "GroupOrderCreatedModal-module-scss-module__TKjS4a__body",
  "footerButton": "GroupOrderCreatedModal-module-scss-module__TKjS4a__footerButton",
  "link": "GroupOrderCreatedModal-module-scss-module__TKjS4a__link",
  "linkInput": "GroupOrderCreatedModal-module-scss-module__TKjS4a__linkInput",
});
